import { render, staticRenderFns } from "./makeSentence.vue?vue&type=template&id=4d796f46&scoped=true"
import script from "./makeSentence.vue?vue&type=script&lang=js"
export * from "./makeSentence.vue?vue&type=script&lang=js"
import style0 from "./makeSentence.vue?vue&type=style&index=0&id=4d796f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d796f46",
  null
  
)

export default component.exports